import { CheckInStatus } from "./enum/checkInStatus";
import { EventFormula } from "./enum/eventFormula";
import {
  ApplyCondition,
  ApplyConditionDto,
  ApplyConditions,
  ApplyConditionType,
} from "./enum/applyCondition";
import { Memo, MemoDto } from "./memo";
import { FanViewLanguage } from "./enum/fanViewLanguage";
import { Period, PeriodDto } from "./period";
import { LocalizedString } from "./localizedString";
import { Notice, NoticeSummaryDto } from "./notice";
import moment from "moment";

export interface CheckInDetailDto {
  eventId: number;
  eventRewardId: number;
  eventCheckInId: number;
  eventInternalTitle: string;
  eventRewardTitle: LocalizedString | null;
  eventPrimaryLanguage: string;
  applyType: string;
  eventPeriod: PeriodDto | null;
  applyConditions: ApplyConditionDto[] | null;
  ticketAvailablePeriod: PeriodDto | null;
  eventCheckInStatus: string;
  eventWinnerNotices: NoticeSummaryDto[];
  eventCheckInMemos: MemoDto[];
  minAge: number;
}

export class CheckInDetail {
  id: number;
  eventId: number;
  rewardId: number;
  internalTitle: string;
  rewardTitle: LocalizedString | null;
  primaryLanguage: FanViewLanguage;
  applyType: EventFormula;
  eventPeriod: Period | null;
  applyConditions: ApplyConditions;
  ticketAvailablePeriod: Period | null;
  checkInStatus: CheckInStatus;
  winnerNotices: Notice[];
  checkInMemos: Memo[];
  minAge: number;

  constructor(dto: CheckInDetailDto) {
    this.id = dto.eventCheckInId;
    this.eventId = dto.eventId;
    this.rewardId = dto.eventRewardId;
    this.internalTitle = dto.eventInternalTitle;
    this.rewardTitle = dto.eventRewardTitle;
    this.primaryLanguage =
      FanViewLanguage[dto.eventPrimaryLanguage as keyof typeof FanViewLanguage];
    this.applyType = EventFormula[dto.applyType as keyof typeof EventFormula];
    this.eventPeriod = dto.eventPeriod && new Period(dto.eventPeriod);
    this.applyConditions = (
      dto.applyConditions?.map(
        (condition) =>
          ({
            type: ApplyConditionType[
              condition.type as keyof typeof ApplyConditionType
            ],
            artistCode: condition.artistCode,
            shopKey: condition.shopKey,
            amount: condition.amount,
            purchaseStartAt: condition.purchaseStartAt
              ? moment(condition.purchaseStartAt)
              : null,
            purchaseEndAt: condition.purchaseEndAt
              ? moment(condition.purchaseEndAt)
              : null,
            membershipRegion: condition.region,
          }) as ApplyCondition,
      ) || []
    ).reduce((acc, condition) => {
      const type = condition.type;
      if (!acc[type]) {
        acc[type] = [];
      }
      acc[type].push(condition);
      return acc;
    }, {} as ApplyConditions);
    this.ticketAvailablePeriod =
      dto.ticketAvailablePeriod !== null
        ? new Period(dto.ticketAvailablePeriod)
        : null;
    this.checkInStatus =
      CheckInStatus[dto.eventCheckInStatus as keyof typeof CheckInStatus];
    this.winnerNotices = dto.eventWinnerNotices.map(
      (notice) => new Notice(notice),
    );
    this.checkInMemos = dto.eventCheckInMemos.map((dto) => new Memo(dto));
    this.minAge = dto.minAge;
  }
}
